
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/accurate",
      function () {
        return require("private-next-pages/accurate.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/accurate"])
      });
    }
  